module.exports = __webpack_public_path__ + "media/src/images/graph_exp02-349802ec31679ce6928929e6f9c88dd0.png";